export const getPaymentToken = (state) => {
    return state.token;
}

export const getFastlane = state => {
    return state.fastlane;
}

export const isCustomerFound = state => {
    return !!state.customerContextId;
}

export const getCanceledEmails = state => {
    return state.canceledEmails;
}